// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-attributes-panel {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  margin: 1.5rem 0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}
.listing-attributes-panel h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1rem;
  letter-spacing: -0.01em;
}

.listing-attributes-grid {
  display: grid;
  grid-template-columns: minmax(8rem, 11rem) 1fr;
  gap: 0.65rem 1.25rem;
  margin: 0;
}

.listing-attributes-grid dt {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin: 0;
  padding-top: 0.1rem;
}

.listing-attributes-grid dd {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.45;
}

@media (max-width: 576px) {
  .listing-attributes-grid {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }
  .listing-attributes-grid dt {
    padding-top: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-attributes-panel/listing-attributes-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,4CAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAGA;EACE,aAAA;EACA,8CAAA;EACA,oBAAA;EACA,SAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE;IACE,0BAAA;IACA,YAAA;EAAF;EAGA;IACE,mBAAA;EADF;AACF","sourcesContent":[".listing-attributes-panel {\n  background: #fff;\n  border: 1px solid #e8ecf0;\n  border-radius: 14px;\n  padding: 1.5rem 1.75rem;\n  margin: 1.5rem 0;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n\n  h3 {\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 1rem;\n    letter-spacing: -0.01em;\n  }\n}\n\n.listing-attributes-grid {\n  display: grid;\n  grid-template-columns: minmax(8rem, 11rem) 1fr;\n  gap: 0.65rem 1.25rem;\n  margin: 0;\n}\n\n.listing-attributes-grid dt {\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin: 0;\n  padding-top: 0.1rem;\n}\n\n.listing-attributes-grid dd {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #1e293b;\n  line-height: 1.45;\n}\n\n@media (max-width: 576px) {\n  .listing-attributes-grid {\n    grid-template-columns: 1fr;\n    gap: 0.35rem;\n  }\n\n  .listing-attributes-grid dt {\n    padding-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
